module.exports = __webpack_public_path__ + "img/8.5ed19924.svg";